import React, { useEffect, useState, useContext } from 'react';
import './mainpage.css';
import Sidebar from './sidebar';
import TopBar from './topbar';
import CornerComponent from './cornercomponent';
import GamePage from './GamePage/gamepage';
import UserContext from '../UserContext';
import { useNavigate } from 'react-router-dom';
import { startTokenChecker } from './account_sync/checker_run';
import HangerPage from './Hanger/Hanger';
import AccountPage from './Account/AccountPage';
import MainContent from './MainContent';
import { EventsProvider } from '../EventsContext';
// ?? new
import { AccountProvider } from '../AccountContext';

const MainPage = () => {
    const [show, setShow] = useState(false);
    const [activePage, setActivePage] = useState('Home');
    const [showGame, setShowGame] = useState(false);

    const { userInfo, clearUser } = useContext(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!userInfo.wallet_address || !userInfo.jwt) {
            navigate('/', { replace: true });
        }
    }, [userInfo, navigate]);

    useEffect(() => {
        const id = requestAnimationFrame(() => setShow(true));
        return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        if (!userInfo.wallet_address || !userInfo.jwt) return;

        const stopChecker = startTokenChecker({
            wallet_address: userInfo.wallet_address,
            jwt: userInfo.jwt,
            onTokenInvalid: () => {
                clearUser();
                sessionStorage.removeItem('userInfo');
                navigate('/');
            },
        });

        return () => stopChecker();
    }, [userInfo.wallet_address, userInfo.jwt, clearUser, navigate]);

    const handleLogout = () => {
        clearUser();
        sessionStorage.removeItem('userInfo');
        navigate('/');
    };

    let content = null;
    if (showGame) {
        content = null;
    } else if (activePage === 'Hanger') {
        content = <HangerPage />;
    } else if (activePage === 'Account') {
        content = <AccountPage onClose={() => setActivePage('Home')} />;
    } else {
        content = <MainContent />;
    }

    return (
        <div className={`main-page${show ? ' fadein' : ''}`}>
            <Sidebar
                activePage={activePage}
                setActivePage={setActivePage}
                onPlayGame={() => setShowGame(true)}
                onLogout={handleLogout}
            />

            <EventsProvider wallet={userInfo?.wallet_address} jwt={userInfo?.jwt}>
                <AccountProvider wallet={userInfo?.wallet_address} jwt={userInfo?.jwt}>
                    <TopBar />
                    <CornerComponent />
                    <div className="content-area">{content}</div>
                </AccountProvider>
            </EventsProvider>

            

            {showGame && <GamePage onClose={() => setShowGame(false)} />}
        </div>
    );
};

export default MainPage;